// extracted by mini-css-extract-plugin
module.exports = {"header":"SingleDay_header__3n45Z","singleDay":"SingleDay_singleDay__7PWg0"};